import React, { useCallback, useEffect, useMemo, useState } from 'react';
import ReactDOM from 'react-dom';

import AddBagSvg from '@/components/common/AddBagSvg';
import CheckmarkSvg from '@/components/common/CheckmarkSvg';

import { IProduct, IProductEdp } from './IProduct';

export interface PdpProps {
    SelectedEdpItem: IProductEdp;
    ProductData: IProduct;
    isAutoDeliveryEnabled: boolean;
}
const domNode = document.getElementById('itemNumberPortal');
if (domNode) {
    domNode.innerHTML = '';
}

const PdpItemNo = ({ SelectedEdpItem, ProductData, isAutoDeliveryEnabled }: PdpProps) => {
    const {
        Name,
        ItemNo,
        DefaultEdp,
        IsSoldOut,
        DeliveryOptions,
        IsPriceRange,
        ShowFreeShipEligibleMessage,
        WasPriceRange,
        ProductReviewCount,
        ProductReviewRating,
        Styles = [],
        Sizes = [],
        AvailableSwatches,
        Edps,
        Brand,
        BrandDimensionId,
        BadgeImagePath,
        ProductTypePath,
    } = ProductData;
    const formatNumber = (itemNo) => {
        return itemNo.replace(/(\d{3})(\d{3})/, '$1-$2');
    };
    const productItemNo = useMemo(() => {
        if (isAutoDeliveryEnabled) {
            const deliveryItemNo = DeliveryOptions.find((item) => item.EdpNo == SelectedEdpItem.EdpNo).ItemNo;
            return formatNumber(deliveryItemNo);
        } else {
            return formatNumber(ItemNo);
        }
    }, [DeliveryOptions, ItemNo, SelectedEdpItem, isAutoDeliveryEnabled]);

    return ReactDOM.createPortal(
        <>
            <div className="pdp-description__sku-number">{productItemNo}</div>
            {window.tscConfig?.AutoFreeShippingEnabled == 'true' &&
                ShowFreeShipEligibleMessage &&
                window.tscConfig?.FreeShippingThreshold && (
                    <div className="freeshipping flex items-center font-semibold">
                        <CheckmarkSvg width="20" height="20" className="mr-1.5" />
                        {`Ships FREE with a $${window.tscConfig?.FreeShippingThreshold}+ order`}
                    </div>
                )}
        </>,
        domNode,
    );
};

export default PdpItemNo;
